// react core
import React, { useState, useEffect, useCallback, useMemo, useContext } from 'react';
import { SimpleMdeReact } from "react-simplemde-editor";
import ReactMarkdown from 'react-markdown';
import { NotificationManager } from 'react-notifications';
import "easymde/dist/easymde.min.css";
import Select from 'react-select'

// components
import AjaxSpinner from 'components/commons/ajax_spinner';
import FileModal from 'components/dialogs/file_upload';
import ImageThumb from 'components/editor_subs/image_thumb';
import FileThumb from 'components/editor_subs/file_thumb';

// user data
import { UserContext } from 'store/user_context';

// api
import { get_tags_from_server } from 'commons/api';
import { parsing_local_html } from 'commons/api';
function Reply(props)
{
    const DEF_VAL = '';
    const base_class = 'add-answer-form';
    const [value, setValue] = useState(DEF_VAL);
    const [tags, setTags] = useState([]);
    const [classes, setClasses] = useState(base_class);
    const [title, setTitle] = useState('');
    const [show_prewivw, setShowPreview] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [modal_is_open, setOpenModal] = useState(false);
    const [editObj, setEditObj] = useState({});
    const [image_array, setImageArray] = useState([]);
    const [blob_array, set_blob_array] = useState([]);
    const [tags_list, set_tag_list] = useState([]);
    const [cur_type, set_cur_type] = useState('image');
    const user_data = useContext(UserContext);

    const on_change = useCallback((value) =>
    {
        setValue(value);
    }, []);

    useEffect(() =>
    {
        let mounted = true;
        get_tags_from_server().then(obj =>
        {
            if(obj && obj.data && obj.status && obj.status === 'ok')
            {
                let tmp = obj.data;
                const all_tags = tmp.map(({ id, name }) => ({ id: id, value: id, label: name }));
                const filterd_tags = all_tags.filter(tag => tag.id != 'other');
                if(mounted)
                {
                    set_tag_list(filterd_tags);
                    setIsLoaded(true);
                }
            }
        });
        return () => mounted = false; // cleanup function
    }, [])


    const get_full_tag_from_id = (id) =>
    {
        const tmp = tags_list.filter(obj => obj.id === id);
        if(tmp.length > 0)
        {
            const obj = tmp[0];
            return {
                'id': obj.id,
                'label': obj.label,
                'value': obj.id
            }
        }
        else return [];
    };

    const on_click = () =>
    {
        if (value !== DEF_VAL)
        {
            if(props.parent_type === 'folder')
            {
                if( (title === '') || (title.length <= 3) || (tags.length < 1) )
                {
                    setClasses(base_class + ' error');
                    NotificationManager.error('Error: missing title or tags');
                    return -1;
                }
            }

            let obj = {
                parent_id: props.pid,
                type: props.type,
                parent_type: props.parent_type,
                data: value,
                tags: tags,
                user: user_data.username,
                title: title,
                image_set: image_array,
                blob_set: blob_array
            };
            setValue(DEF_VAL);
            setTags([]);
            setTitle('');
            setClasses(base_class);
            setImageArray([]);
            set_blob_array([]);
            props.onSend(obj);
        }
        else
        {
            setClasses(base_class + ' error');
        }
    };

    // Make sure to always `useMemo` all the `options` and `events` props to ensure best performance!
    const events = useMemo(() =>
    {
        return {
            focus: () =>
            {
                if (value === DEF_VAL)
                {
                    setValue('');
                }
            }
        }
    }, [value]);

    const handleTitleChange = evt =>
    {
        setTitle(evt.target.value);
    };

    const renderTitle = () =>
    {
        if (props.show_title)
        {
            return (<>
                <input className="title-field" type="text" placeholder="Summarize your question in a one-line title" value={title} onChange={handleTitleChange} />
                </>
            );
        }
    }

    const handle_select_change = (values) =>
    {
        let tmp = values.map(({ id, value, label }) => ({id:id, text:id}));
        setTags(tmp);
    };


    const renderTags = () =>
    {
        if (props.show_tags)
        {
            return (
                <Select
                    options={tags_list}
                    isMulti
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={handle_select_change}
                    placeholder="Select the related tags"
                    value={tags.map(i => get_full_tag_from_id(i.id))}
                />
            );
        }
    };

    const uploader_clicked = (evt) =>
    {
        setOpenModal(true);
    };

    const abort_modal = (evt) =>
    {
        // very strange bug... fired twice?
        if(evt && evt.isPassive === false) return -1;
        setOpenModal(false);
    };

    const close_modal = (evt, data) =>
    {
        setOpenModal(false);
        if(data.attach_type === 'image')
        {
            const id = (image_array.length <1) ? 1 : 1+Math.max(...image_array.map(item => parseInt(item.id.split('_')[1])));
            data.id = 'image_' + id.toString();
            let tmp = image_array.filter(item  => item.md5 === data.md5);
            if(tmp.length > 0)
            {
                NotificationManager.error('Error: you cannot add images with the same name', 'Ok!', 5000, () => {});
            }
            else
            {
                const image_text = `![${data.title}](${data.id})`;
                if(editObj.doc) editObj.doc.replaceRange(image_text, editObj.pos)
                NotificationManager.success('Added image', data.title || 'no title');
                setImageArray(oldValues => [...oldValues, data]);
            }
        }
        else if(data.attach_type === 'attach')
        {
            const id = (blob_array.length <1) ? 1 : 1+Math.max(...blob_array.map(item => parseInt(item.id.split('_')[1])));
            data.id = 'file_' + id.toString();
            let tmp = blob_array.filter(item  => item.md5 === data.md5);
            if(tmp.length > 0)
            {
                NotificationManager.error('Error: you cannot add files with the same name', 'Ok!', 5000, () => {});
            }
            else
            {
                const file_text = `[${data.title}](${data.id})`;
                if(editObj.doc) editObj.doc.replaceRange(file_text, editObj.pos)
                NotificationManager.success('Added file', data.title || 'no title');
                set_blob_array(oldValues => [...oldValues, data]);
            }
        }
        else
        {
            console.error('wrong type');
        }
    }

    const image_array_remove = (evt, idx) =>
    {
        let old_array = image_array;
        let new_array = old_array.filter(item => item.id !== idx);
        let tmp = old_array.filter(item  => item.id === idx);
        if(tmp.length > 0)
        {
            let data = tmp[0];
            const image_text = `![${data.title}](${data.id})`;
            if(editObj.doc)
            {
                let old_text = editObj.doc.getValue();
                old_text = old_text.replace(image_text, '');
                editObj.doc.setValue(old_text);
                const cursor = editObj.doc.getCursor();
                editObj.doc.setCursor(cursor);
            }
        }
        setImageArray(new_array);
    }

    const blob_array_remove = (evt, idx) =>
    {
        let old_array = blob_array;
        let new_array = old_array.filter(item => item.id !== idx);
        let tmp = old_array.filter(item  => item.id === idx);
        if(tmp.length > 0)
        {
            let data = tmp[0];
            const image_text = `[${data.title}](${data.id})`;
            if(editObj.doc)
            {
                let old_text = editObj.doc.getValue();
                old_text = old_text.replace(image_text, '');
                editObj.doc.setValue(old_text);
                const cursor = editObj.doc.getCursor();
                editObj.doc.setCursor(cursor);
            }
        }
        set_blob_array(new_array);
    };

    const edit_opstions = useMemo(() =>
    {
        let inser_image = {};
        let inser_attach = {};
        let opts =
        {
            minHeight: '200px',
            toolbar: ['bold', 'italic', 'strikethrough', '|', 'heading-1', 'heading-2', 'heading-3', '|',  ]
        }
        if(props.show_attach)
        {
            inser_image =
            {
                name: "uploader",
                action: function customFunction(editor)
                {
                    // getting current position
                    const cursor = editor.codemirror.getCursor();
                    const doc = editor.codemirror.getDoc();
                    const obj = {};
                    obj.pos = cursor;
                    obj.doc = doc;
                    setEditObj(obj);
                    set_cur_type('image');
                    uploader_clicked();
                },
                className: "fa fa-image",
                title: "Upload an image",
            };
            opts.toolbar.push(inser_image);
            inser_attach =
            {
                name: "file_uploader",
                action: function customFunction(editor)
                {
                    // getting current position
                    const cursor = editor.codemirror.getCursor();
                    const doc = editor.codemirror.getDoc();
                    const obj = {};
                    obj.pos = cursor;
                    obj.doc = doc;
                    setEditObj(obj);
                    set_cur_type('attach');
                    uploader_clicked();
                },
                className: "fa fa-paperclip",
                title: "Attach a file",
            };
            opts.toolbar.push(inser_attach);
        }
        opts.placeholder = props.placeholder;
        opts.spellChecker = false;
        opts.toolbar = opts.toolbar.concat(['code',  "quote", 'unordered-list', 'ordered-list', '|', 'guide',])
        return opts;
    }, [props.show_attach, props.placeholder]);

    const show_prewivw_panel = (evt) =>
    {
        setShowPreview(true);
    };

    const hide_prewivw_panel = (evt) =>
    {
        setShowPreview(false);
    };

    if(isLoaded)
    {
        return (
            <div className={classes}>
                <div className="add-answer-form-header">
                    <div>{modal_is_open}</div>
                    <FileModal modal_open={modal_is_open} close_cb={abort_modal} ok_cb={close_modal} attach_type={cur_type}/>
                    {renderTitle()}
                    {renderTags()}
                </div>

                <div className='add-answer-form-body'>
                    {show_prewivw !== true && <SimpleMdeReact events={events} value={value} options={edit_opstions} onChange={on_change} />}

                    {show_prewivw !== true && image_array.length > 0 && props.show_attach && <div className='add-answer-form-body-images'><h3>Images to include</h3>
                        {
                            image_array.map(item => <ImageThumb
                                key={item.md5}
                                id={item.id}
                                filename={item.id}
                                title={item.title}
                                base64={item.data}
                                onRemove={image_array_remove}
                            />)
                        }
                     </div>}
                     {show_prewivw !== true && blob_array.length > 0 && props.show_attach && <div className='add-answer-form-body-images'><h3>Files to include</h3>
                     {
                        blob_array.map(item => <FileThumb
                                key={item.md5}
                                id={item.id}
                                filename={item.id}
                                title={item.title}
                                onRemove={blob_array_remove}
                            />)
                        }
                    </div>}
                    <div>
                    {show_prewivw && <h3>Preview</h3>}
                    {show_prewivw && <ReactMarkdown className='preview'>{parsing_local_html(value, image_array)}</ReactMarkdown>}
                    </div>
                </div>

                <div className="add-answer-form-footer">
                    {!show_prewivw && <button className='button button-small' onClick={show_prewivw_panel}>Show Preview</button>}
                    {show_prewivw && <button className='button button-secondary button-small' onClick={hide_prewivw_panel}>Hide Preview</button>}
                    <button className='button button-primary button-small'  onClick={on_click}>{props.button_text}</button>
                </div>

            </div>
        );
    }
    else return <AjaxSpinner/>;

};

Reply.defaultProps = {
    show_title: false,
    show_tags: false,
    button_text: 'reply',
    show_labels: false,
    show_attach: true,
    placeholder: 'Describe your question in more detail'
}

export default Reply;